import { endpoints, baseurl } from "../Utils/Constants";

export const getAllPOSList = async (token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_ALL_POS_LIST, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${token}`
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching POS list:', error);
        throw error;
    }
};

export const saveOrganization = async (organizationData, token) => {
    try {
        const response = await fetch(baseurl + endpoints.SAVE_ORGANIZATION, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify(organizationData)
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error saving organization:', error);
        throw error;
    }
};

export const validateNpiNumber = async (npiNumber, token) => {
    try {
        const response = await fetch(baseurl + endpoints.VALIDATE_NPI + npiNumber, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${token}`
            }
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error validating NPI number:', error);
        throw error;
    }
};


export const uploadOrganizationDocuments = async (formData, token) => {
    try {
        const response = await fetch(baseurl + endpoints.UPLOAD_ORG_DOCS, {
            method: 'POST',
            headers: {
                "Authorization": `Bearer ${token}`
            },
            body: formData
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error uploading organization documents:', error);
        throw error;
    }
};

export const getAllOrganizations = async (token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_ALL_ORGANIZATIONS, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${token}`
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching organizations:', error);
        throw error;
    }
};

export const getOrganizationById = async (organizationId, token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_ORGANIZATION_BY_ID + organizationId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${token}`
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching organization by ID:', error);
        throw error;
    }
};

export const getAllDocumentsByOrgId = async (organizationId, token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_ALL_DOCUMENTS_BY_ORG_ID + organizationId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${token}`
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching documents by organization ID:', error);
        throw error;
    }
};

export const getDocumentById = async (documentId, token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_DOCUMENT_BY_ID + documentId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${token}`
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching document by ID:', error);
        throw error;
    }
};

export const deleteDocumentById = async (documentId, token) => {
    try {
        const response = await fetch(baseurl + endpoints.DELETE_DOCUMENT_BY_ID + documentId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${token}`
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error deleting document by ID:', error);
        throw error;
    }
};

export const saveOrganizationTransition = async (transitionData, token) => {
    try {
        const response = await fetch(baseurl + endpoints.SAVE_ORG_TRANSITION, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify(transitionData)
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error saving organization transition:', error);
        throw error;
    }
};

export const getOrganizationTransitionByOrgId = async (organizationId, token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_ORG_TRANSITION_BY_ORG_ID + organizationId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${token}`
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching organization transition by ID:', error);
        throw error;
    }
};

export const saveOrganizationSOP = async (sopData, token) => {
    try {
        const response = await fetch(baseurl + endpoints.SAVE_SOP, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify(sopData)
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error saving organization SOP:', error);
        throw error;
    }
};

export const getOrganizationSOP = async (organizationId, token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_ORG_SOP + organizationId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${token}`
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching organization SOP by ID:', error);
        throw error;
    }
};

export const saveOrganizationReport = async (reportData, token) => {
    try {
        const response = await fetch(baseurl + endpoints.SAVE_ORG_REPORTS, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify(reportData)
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error saving organization report:', error);
        throw error;
    }
};

export const getAllOrganizationReports = async (organizationId, token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_ALL_ORG_REPORTS + organizationId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${token}`
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching organization reports:', error);
        throw error;
    }
};

export const getOrganizationReportById = async (reportId, token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_ORG_REPORT_BY_ID + reportId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${token}`
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching organization report by ID:', error);
        throw error;
    }
};

export const deleteOrganizationReportById = async (reportId, token) => {
    try {
        const response = await fetch(baseurl + endpoints.DELETE_ORG_REPORT_BY_ID + reportId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${token}`
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error deleting organization report by ID:', error);
        throw error;
    }
};

export const deleteOrganization = async (organizationId, token) => {
    try {
        const response = await fetch(baseurl + endpoints.DELETE_ORGANIZATION + organizationId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${token}`
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error deleting organization:', error);
        throw error;
    }
};

export const downloadOrganizationDocument = async (fileId, token) => {
    try {
        const response = await fetch(baseurl + endpoints.DOWNLOAD_ORG_DOCUMENT + fileId, {
            method: 'GET',
            headers: {
                "Authorization": `Bearer ${token}`
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error downloading organization document:', error);
        throw error;
    }
};

export const getAllOrganizationNames = async (token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_ALL_ORGANIZATION_NAMES, {
            method: 'GET',
            headers: {
                "Authorization": `Bearer ${token}`
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching organization names:', error);
        throw error;
    }
};

export const getOrgMembersByOrgId = async (organizationId, token) => {
    try {
        const url = organizationId ? baseurl + endpoints.GET_ORG_MEMBERS + organizationId : baseurl + '/organization/getMembersByOrganizationId';
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                "Authorization": `Bearer ${token}`
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching organization members by ID:', error);
        throw error;
    }
};

export const getOrgMemberDetails = async (organizationId, token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_ORG_MEMBER_DETAILS + organizationId, {
            method: 'GET',
            headers: {
                "Authorization": `Bearer ${token}`
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching organization member details:', error);
        throw error;
    }
};

export const getOrganizationAnalytics = async (organizationId, token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_ORG_ANALYTICS + organizationId, {
            method: 'GET',
            headers: {
                "Authorization": `Bearer ${token}`
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching organization analytics:', error);
        throw error;
    }
};




